import { BottomSheet, Text, type UseModalState } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { isCapacitorPlatform, isIosPlatform } from "@src/appV2/lib";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";

interface LocationPermissionDialogProps {
  modalState: UseModalState;
  onConfirm: () => void;
  onRequestNativePermissions?: () => void;
  isOsWithoutAlwaysAllow: boolean;
}

export function LocationPermissionDialog(props: LocationPermissionDialogProps) {
  const { modalState, onConfirm, onRequestNativePermissions, isOsWithoutAlwaysAllow } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter
          orientation="vertical"
          onClose={() => {
            modalState.closeModal();
          }}
        >
          {isCapacitorPlatform() && onRequestNativePermissions && (
            <LoadingButton
              fullWidth
              variant="contained"
              size="large"
              isLoading={false}
              onClick={onRequestNativePermissions}
            >
              Request Permission
            </LoadingButton>
          )}
          <LoadingButton
            fullWidth
            variant="outlined"
            size="large"
            isLoading={false}
            onClick={onConfirm}
          >
            Go To Settings
          </LoadingButton>
        </DialogFooter>
      }
    >
      <Box sx={{ py: 8, px: 4 }}>
        <Stack spacing={8} alignItems="center" justifyContent="center">
          <Box display="flex" justifyContent="center">
            <img src="assets/logo/bunny.png" alt="Clipboard logo" width={100} />
          </Box>

          <Text variant="h4" textAlign="center" sx={{ fontWeight: "bold" }}>
            Enable location permissions
          </Text>

          <Stack spacing={4} alignItems="center" justifyContent="center">
            <Text variant="body1" textAlign="center">
              {isOsWithoutAlwaysAllow ? (
                <>
                  We need you to enable Location permissions in your device settings, so we can
                  confirm you&apos;re coming to your interview. This lets facilities know
                  you&apos;re on your way and helps avoid any check-in issues.
                </>
              ) : (
                <>
                  We need you to enable the{" "}
                  <b>{isIosPlatform() ? "Always" : "Allow all the time"}</b> and{" "}
                  <b>Precise Location</b> permissions in your device settings, so we can confirm
                  you&apos;re coming to your interview. This lets facilities know you&apos;re on
                  your way and helps avoid any check-in issues.
                </>
              )}
            </Text>
          </Stack>
        </Stack>
      </Box>
    </BottomSheet>
  );
}
